// CONTEXTS
import { OpenPartOrdersProvider } from "../../../contexts/parts/openPartOrders.context";
// COMPONENTS
import LoggedIn from "../../../layouts/loggedIn.layout";
import OpenPartsPage from "./page.openParts.page";

const OpenPartsLayout = () => {
  return (
    <LoggedIn>
      <OpenPartOrdersProvider>
        <OpenPartsPage />
      </OpenPartOrdersProvider>
    </LoggedIn>
  );
};

export default OpenPartsLayout;
